import React from "react"
import { Input, InputProps } from "../atoms/Input"
import { cn } from "../utils"

export const InputColor = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <div className={cn("relative", className)}>
        <div
          className="w-[20px] h-[20px] rounded-full absolute top-2 left-3 z-10 border"
          style={{ backgroundColor: props.value?.toString() ?? "#CCC" }}
        >
          <input
            type="color"
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            onChange={props.onChange}
          />
        </div>
        <Input className="pl-10" {...props} ref={ref} />
      </div>
    )
  },
)
